import { connect } from 'react-redux';
import MessageTab from '../components/message-tab';
import {
  fetchActionRequiredMessages,
  dismissMessage,
  setFastPollingRequest,
  setSlowPollingRequest,
} from './message-center-actions';
import { openPlanningAndView } from '../../gantt/containers/gantt-actions';

const mapStateToProps = state => ({
  messages: state.messageCenter.messages,
  error: state.messageCenter.error,
  isDismissing: state.messageCenter.isDismissing,
  isLoading: state.messageCenter.isLoadingMessages,
});

const mapDispatchToProps = {
  fetchData: fetchActionRequiredMessages,
  dismissMessage,
  setFastPolling: setFastPollingRequest,
  setSlowPolling: setSlowPollingRequest,
  openPlanningAndView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MessageTab);
